<app-page-meta pageTitle="finzy - Invest"></app-page-meta>
<app-header></app-header>
<div>
    <div *ngIf="areInvestmentsAvailable()">
        <p class="heading"><span>Choose how you want to invest</span></p>
        <div class="text">
            <p>
                For your investment portfolio of <b>&#8377; {{userOptedInvestmentDetail.investmentAmount}}</b>, you have
                <b>manually picked {{userOptedInvestmentDetail.numberOfLoansSelected}} loan(s)</b> worth
                <b>&#8377; {{userOptedInvestmentDetail.investmentAmount - userOptedInvestmentDetail.pendingAmountToInvest}}</b>.
                You have <b>&#8377; {{userOptedInvestmentDetail.pendingAmountToInvest}} more left to invest</b>. We will
                help allot this amount in new loans as they get listed on the platform. You can either choose the
                finzyPRO+ option or customise your investment preferences below. However, if you wish to go back to
                manually picking your loans <a class="back-link" (click)="backToPreviousPage()">click here</a>.
            </p>
        </div>
    </div>
    <div *ngIf="!areInvestmentsAvailable()">
        <p class="heading"><span>Currently there are no loans available</span></p>
        <div class="text">
            <p>
                We will help you invest your portfolio of <b>&#8377; {{userOptedInvestmentDetail.investmentAmount}}</b>
                in new loans as they get listed on the platform. You can either choose the finzyPRO+ option or customise
                your investment preferences below.
            </p>
        </div>
    </div>
    <div class="preference-content">
        <div>
            <div class="preference-option row">
                <div class="col-xs-12">
                    <div class='row'>
                        <div class="col-md-8 col-sm-12">
                            <p class="preference-option-heading-text">
                                Continue with your default finzyPRO+ preferences
                            </p>
                            <div class="preference-option-sub-heading-text">
                                By clicking on confirm investment, Your portfolio amount will be allocated into new
                                loans
                                using your default preferences:
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-12 preference-option-button-container">
                            <button mat-flat-button class="primary preference-option-button" type="button"
                                    (click)="saveFinzyProPreference()">
                                CONTINUE WITH finzyPRO+
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <app-selected-preferences class="col-xs-12" [preferredCategories]="initialPreferredCategories">
                        </app-selected-preferences>
                    </div>
                </div>
            </div>
            <div class="row">
                <img class="or-line-divider img-fluid" src="../../../assets/images/or.svg">
            </div>

            <div class="row" [class.bordered]="isCustomPreferenceExpanded">
                <div class="col-xs-12">
                    <div class='row preference-option'>
                        <div class="col-md-8 col-sm-12">
                            <p class="preference-option-heading-text">
                                Customise finzyPRO+
                            </p>
                            <p class="preference-option-sub-heading-text">
                                You can control how finzyPRO+ invests into loans by selecting custom filters. Selecting
                                only 1 or 2 categories could increase the time taken to deploy your investments.
                            </p>
                        </div>
                        <div class="col-md-4 col-sm-12 preference-option-button-container">
                            <button mat-flat-button *ngIf="!isCustomPreferenceExpanded"
                                    class="primary preference-option-button"
                                    type="button" (click)="onSetPreferenceClick()">
                                SET PREFERENCES
                            </button>
                        </div>
                    </div>
                    <div class="row" id="customPreference" *ngIf="isCustomPreferenceExpanded">
                        <div class="col-sm-12">
                            <p class="preference-option-heading-text">
                                <span>Select Investment Preference</span>
                            </p>
                            <p class="preference-option-sub-heading-text">
                                We will automatically pick the loans from selected category.
                            </p>
                            <app-rating-selector [(preferredCategories)]="preferredCategories"></app-rating-selector>
                            <p class="preference-option-sub-heading-text" *ngIf="getWaitTime(preferredCategories)">
                                Please note we have experienced wait times of upto {{getWaitTime(preferredCategories)}}
                                in this selection category.
                            </p>
                            <br>

                            <button mat-flat-button class="primary pull-right preference-option-button"
                                    type="button"
                                    [disabled]="!isValidPreferenceSelection()"
                                    (click)="saveCustomPortfolioPreference()">
                                CONTINUE
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="back-div">
            <a class="back-link" (click)="backToPreviousPage()">Go Back</a> to pick loans
            manually
        </div>
    </div>
</div>
<app-footer></app-footer>
